module.exports = __webpack_public_path__ + "img/avatar.40ae4e11.jpg";